import styled from 'styled-components'

export const ProductDetailWrapper = styled.section`
.heading{
    font-family: Motiva-Medium,Motiva,Helvetica,Arial,sans-serif;
    font-weight: 500;
    color: #000;
    font-size: 26px;
    line-height: 36px;
    margin: 0 0 12px;
    text-align: start;
    font-weight: 600;
}

.img-big-wrap{
    border:0;
}

.item-number{
    font-size: 13px;
    display: inline-block;
    margin: 0 3px;
    font-family: Motiva-Light,Motiva,Helvetica,Arial,sans-serif;
}

`